/**
 * Scope the manage page's "pick a new time" link to the location the
 * appointment was booked at. A business with more than one location would
 * otherwise drop the customer on the bare booking root, which can resolve to
 * a different place than the visit they are moving.
 *
 * `scheduleId` must be the business schedule (user-facing: the "Location").
 * An appointment on a team member's calendar carries that member schedule,
 * whose `parentScheduleId` is the location the booking page lists; a member
 * calendar id matches nothing there and the deep link is ignored.
 *
 * It is never a customer or appointment id: the manage capability stays out
 * of the ordinary booking query string
 * (`booking-flow.instructions.md` § 8 Reschedule).
 */
export function buildScopedBookingHref(
  bookHref: string,
  scheduleId?: string | null,
): string {
  if (!scheduleId) return bookHref;

  const hashAt = bookHref.indexOf("#");
  const hash = hashAt === -1 ? "" : bookHref.slice(hashAt);
  const base = hashAt === -1 ? bookHref : bookHref.slice(0, hashAt);

  const queryAt = base.indexOf("?");
  const path = queryAt === -1 ? base : base.slice(0, queryAt);
  const params = new URLSearchParams(
    queryAt === -1 ? "" : base.slice(queryAt + 1),
  );
  // An explicit schedule on the caller's href wins; it was chosen on purpose.
  if (params.has("schedule")) return bookHref;

  params.set("schedule", scheduleId);
  return `${path}?${params.toString()}${hash}`;
}
